import {
  AutomotiveAftermarketTileType,
  AutomotiveAftermarketTypeView,
  AutomotiveAftermarketTypeViewType,
  Permission,
} from '../../..';

export function convertTileType(
  tileType: { [key in AutomotiveAftermarketTileType]: boolean },
  tileTypePermissions: { [key in Permission]: boolean },
): AutomotiveAftermarketTypeViewType[] {
  return Object.keys(tileType)
    .filter(
      (key: AutomotiveAftermarketTileType) =>
        tileType[key] &&
        tileTypePermissions[
          Permission[
            Object.keys(AutomotiveAftermarketTileType)[Object.values(AutomotiveAftermarketTileType).indexOf(key)]
          ]
        ],
    )
    .map((tileTypeKey: string) => AutomotiveAftermarketTypeView[tileTypeKey.toUpperCase()[0] + tileTypeKey.slice(1)]);
}
